export default "__VITE_ASSET__C$cgshbk__"